// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import zenscroll from 'zenscroll'
import { DateTime } from 'luxon'

// Internal Dependencies:
import Schedule from 'components/Schedule/Schedule'
import CurrentPlaylist from 'components/NowPlaying/CurrentPlaylist'
import LoadingSpinner from 'components/LoadingSpinner/LoadingSpinner'
import { getUtcTimestampSeconds } from 'utilities/time'

// Redux:
import { toggleAccountDropdown } from 'actions/site'
import { getFullScheduleData, goToTrack } from 'actions/schedule'

class MiniSchedule extends React.Component {
	constructor( props ) {
		super( props )

		let state = {
			isOpen: false,
			scheduleShow: 'next',
			currentDateTime: DateTime.local(),
			selectedWeekDay: DateTime.local().toFormat( 'EEEE' ),
			selectedMonth: DateTime.local().toFormat( 'MM' ),
			selectedDay: DateTime.local().toFormat( 'dd' )
		}

		this.state = state
	}

	handleClickOpen = () => {
		this.setState( {
			isOpen: ! this.state.isOpen
		} )
	}

	scheduleShowAfterNow = () => {
		this.setState( {
			scheduleShow: 'next'
		} )
	}

	scheduleShowBeforeNow = () => {
		this.setState( {
			scheduleShow: 'previous'
		} )
	}

	render() {
		const { fullSchedule, nowPlaying, siteId, stationsById, timezoneType, page, programClickPlayDirect } = this.props
		const { isOpen, currentDateTime, selectedDay, selectedWeekDay, selectedMonth } = this.state
		let { scheduleShow } = this.state
		const className = isOpen ? 'now-playing-playlist is-open' : 'now-playing-playlist'
		const toggleText = isOpen ? 'Hide playlist' : 'Show playlist'

		if ( ! fullSchedule ) {
			return null
		}

		if ( nowPlaying.is_playlist ) {
			scheduleShow = 'playlist'
		}

		return (
			<div className={ className }>
				<div className="-inner">
					<div className="-toggle" onClick={ this.handleClickOpen }>
						<div className="-toggle-text">{ toggleText }</div>
					</div>

					<div className="breakpoint-small">
						<div className="schedule-page-wrap">
							<div className="now-playing-schedule-wrap">
								{ ( 'next' == scheduleShow || 'previous' == scheduleShow ) &&
									<div className="now-playing-schedule-controls">
										<div className={ 'next' == scheduleShow ? '-button is-active' : '-button' } onClick={ this.scheduleShowAfterNow }>Up Next</div>

										<div className={ 'previous' == scheduleShow ? '-button is-active' : '-button' } onClick={ this.scheduleShowBeforeNow }>Recently Played</div>
									</div>
								}

								{ 'next' == scheduleShow &&
									<div className="schedule-programs-wrap">
										<Schedule
											isListenPage={ true }
											dateTime={ currentDateTime }
											selectedDay={ selectedDay }
											selectedWeekDay={ selectedWeekDay }
											selectedMonth={ selectedMonth }
											showAfterNow={ true }
											programClickPlayDirect={ programClickPlayDirect }
										/>
									</div>
								}

								{ 'previous' == scheduleShow &&
									<div className="schedule-programs-wrap">
										<Schedule
											isListenPage={ true }
											dateTime={ currentDateTime }
											selectedDay={ selectedDay }
											selectedWeekDay={ selectedWeekDay }
											selectedMonth={ selectedMonth }
											showBeforeNow={ true }
											programClickPlayDirect={ programClickPlayDirect }
										/>
									</div>
								}

								{ 'playlist' == scheduleShow &&
									<div className="program-podcasts">
										<div className="schedule-programs-wrap">
											<CurrentPlaylist />
										</div>
									</div>
								}

								{ ( 'next' == scheduleShow || 'previous' == scheduleShow ) &&
									<Link to="/schedule" className="schedule-full-button">
										<div className="-icon">
											<i className="icon-calendar" />
										</div>

										<div className="-text">View Full Schedule</div>
									</Link>
								}
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		isMobile: state.site.isMobile,
		page: state.page.selected,
		fullSchedule: state.schedule.fullSchedule,
		programsById: state.programs.byId,
		nowPlaying: state.schedule.nowPlaying,
		mediaError: state.schedule.mediaError,
		timezone: state.schedule.timezone,
		timezoneOffset: state.schedule.timezoneOffset,
		timezoneType: state.schedule.timezoneType,
		siteId: state.schedule.siteId,
		stationsById: state.schedule.stationsById,
		selectedItem: state.schedule.selectedItem,
		rewindMaxHours: state.schedule.rewindMaxHours,
		allowFutureFastForward: state.schedule.allowFutureFastForward,
		accountDropdownIsOpen: state.site.accountDropdownIsOpen
	}
}

const mapDispatchToProps = ( dispatch, ownProps ) => {
	return {
		getFullScheduleData( day, month, daysOffset, daysOffsetDirection ) {
			dispatch( getFullScheduleData( day, month, daysOffset, daysOffsetDirection ) )
		},

		toggleAccountDropdown() {
			dispatch( toggleAccountDropdown() )
		},

		goToTrack( key ) {
			dispatch( goToTrack( key ) )
		}
	}
}

export default connect( mapStateToProps, mapDispatchToProps )( MiniSchedule )
